module.exports = __webpack_public_path__ + "img/bookshelf.e0583eee.png";